import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiurl } from "../Constants";

export const fetchAdvertisementhome = createAsyncThunk(
  "advertisementhome/fetchAdvertisementhome",
  async () => {
    const response = await axios.get(apiurl + "homeadvertisement");
    return response.data.data; // Assuming the banner data is in `data`
  }
);

const initialState = {
  advertisementhomedata: [], // Correct key here
  loading: false,
  status: "idle",
  error: null,
};

const advertisementhomeSlice = createSlice({
  name: "advertisementhome",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdvertisementhome.pending, (state) => {
        state.loading = true;
        state.status = "loading";
      })
      .addCase(fetchAdvertisementhome.fulfilled, (state, action) => {
        state.loading = false;
        state.status = "succeeded";
        state.advertisementhomedata = action.payload;
      })
      .addCase(fetchAdvertisementhome.rejected, (state, action) => {
        state.loading = false;
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default advertisementhomeSlice.reducer;
